import {useMemo} from 'react';
import {IProductShort} from 'modules/products/types';
import {IProduct} from 'modules/product-card/models/ProductResponse';

export const useProductAvailability = (product: IProductShort | IProduct, isPrive: boolean) => {
    return useMemo(() => {
        const {canBuy, canReserve} = product;

        if (canBuy) {
            return 'IN_STOCK';
        }

        if (canReserve && !isPrive) {
            return 'FOR_RESERVATION';
        }

        return 'OUT_OF_STOCK';
    }, [product, isPrive]);
};
